import { Button, Dialog, DialogActions, DialogContent, DialogTitle,FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch } from "@mui/material";
import { styled } from '@mui/material/styles';
import classes from "./Packages.module.scss"
import { useState } from "react";

const PayTypeSwitch = ({payType, setPayType, currentPayType}) => {
    //const [payType, setPayType] = useState("Monthly");
    const MaterialUISwitch = styled(Switch)(({ theme }) => ({
        width: 62+40,
        height: 34,
        padding: 7,
        '& .MuiSwitch-switchBase': {
          margin: 1,
          padding: 0,
          transform: 'translateX(6px)',
          '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(62px)',
            '& .MuiSwitch-thumb:before': {
              backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                '#fff',
              )}" d="M19,4h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20 H5V10h14V20z M9,14H7v-2h2V14z M13,14h-2v-2h2V14z M17,14h-2v-2h2V14z M9,18H7v-2h2V18z M13,18h-2v-2h2V18z M17,18h-2v-2h2V18z"/></svg>')`,
            },
            '& + .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: '#28b6f6',
            },
          },
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: '#047f04',
          width: 32,
          height: 32,
          '&::before': {
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
              '#fff',
            )}" d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/></svg>')`,
          },
        },
        '& .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: "#28b6f6",
          borderRadius: 20 / 2,
        },
      }));
    
    const onChangeValue = (e) => {
        if(e.target.checked)
            setPayType("Yearly");
        else
            setPayType("Monthly");
    }
    return(
        <div className="d-flex align-items-center justify-content-center">
            <div className={classes["switch-label"]} aria-selected={payType==="Monthly"} onClick={() =>setPayType("Monthly")}>
              Monthly
              {currentPayType && currentPayType !== payType && <div className={classes["bubble"]}>
                <span>Currently active</span>
              </div>}
            </div>
                <MaterialUISwitch sx={{ m: 1 }} onChange={onChangeValue} checked={payType==="Yearly"} inputProps={{ 'aria-label': 'controlled' }}/>
            <div className={classes["switch-label"]} aria-selected={payType==="Yearly"} onClick={() =>setPayType("Yearly")}>Yearly</div>
        </div>
    )
}


export default PayTypeSwitch;